export default function getTotalEarnings(
  earningsData: Partial<RangeEarningsEntry>[],
) {
  return earningsData.reduce(
    (totalEarnings, eachEarning) =>
      totalEarnings +
      (eachEarning?.earnings?.transfer_to_orchid_pro || 0) +
      (eachEarning?.earnings?.invoice_paid_by_patient || 0),
    0,
  );
}
